import { ThreeView } from "./index";

export class SceneExtrasMaterial {

    private extras: any;
    constructor() {
        this.extras = ThreeView.get().wcItemmgr.GltfExtras;
    }

    update(name: string, textureName: string) {

        const materials = this.extras.material;

        const material = materials.find(material => material.name == name);

        if (material == null) {
            materials.push({name:name, value:textureName});
            return;
        };
        material.value = textureName
    }

    updatePointTexture(meshName: string, textureName: string) {
        // "individual": [
        //     {
        //         "node_id": "rom10-01-05-wall-node",
        //         "material": "cloth4_img"
        //     },
        //     {
        //         "node_id": "rom10-01-05-kosi-node",
        //         "material": "cloth4_img"
        //     }
        // ],
        if (this.extras.individual == null) {
            this.extras.individual = [];
        }
        const materials = this.extras.individual;
        const material = {
            "node_id": meshName,
            "material": textureName
        };

        const index = materials.findIndex((material) => material.node_id == meshName);
        if (index == -1) {
            materials.push(material);
            return;
        }

        materials[index] = material;
    }
}
